import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThemePalette } from '@angular/material/core';
import { MatCardModule } from '@angular/material/card';
import { MatBadgeModule } from '@angular/material/badge';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { AlertService } from 'src/app/shared/services/utilities/alert.service';
import { AnalyticsService } from 'src/app/shared/services/analytics.service';


@Component({
    selector: 'ri-home-card',
    templateUrl: './home-card.component.html',
    styleUrls: ['./home-card.component.scss'],
    host: { class: 'home-card' },
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, MatCardModule, MatBadgeModule, MatIconModule, MatTooltipModule, TranslatePipe],
})
export class HomeCardComponent implements OnInit {
  translatedTitle: string = "";
  private currentTitleKey!: string;
@Input()
set title(value: string) {
  this.currentTitleKey = value;
  this.translateTitle(value);
}
@Input() disabled = false;
  @Input() disabledMessage = '';
  @Input() iconName="";
  @Input() routeTo: string[] = [];
  @Input() badgeColor: ThemePalette = "primary";
  @Input() badgeText: any = null;
  @Output() clicked=new EventEmitter<void>();



  //Add output event to handle click




  constructor(private router: Router, private translate:TranslateService, private alertService: AlertService, private analytics: AnalyticsService, private cd: ChangeDetectorRef) {
    this.translate.onLangChange.subscribe(() => {
      this.translateTitle(this.currentTitleKey);
    });

   }

  get isExternalRoute(): boolean {
    return this.routeTo.length > 0 && this.isExternalUrl(this.routeTo[0]);
  }

  get titleFontClass(): string {
    const len = this.translatedTitle.length;
    if (len > 16) return 'title-long';
    if (len > 10) return 'title-medium';
    return '';
  }

  ngOnInit(): void {}

  public translateTitle(key?: string) {
    const effectiveKey = key || this.currentTitleKey;
  if (!effectiveKey) return;  // Still need to check if there's nothing to translate

  const translationKey = `${effectiveKey}`;
  this.translate.get(translationKey).subscribe((res: string) => {
    this.translatedTitle = res;
    this.cd.markForCheck();
  });
  }
  handleClick() {
    if (this.disabled) {
      const reason = this.disabledMessage ? 'project_settings' : 'unsigned_onboarding_forms';
      this.analytics.trackAction('card_click_disabled', 'home', 'home-card', this.translatedTitle, {
        titleKey: this.currentTitleKey,
        reason,
      });
      this.alertService.openDialog(
        this.translate.instant('homeCard.actionDisabled'),
        this.disabledMessage || this.translate.instant('homeCard.unsignedOnboardingForms')
      );
      return;
    }

    // Track card click
    this.analytics.trackAction('card_click', 'home', 'home-card', this.translatedTitle, {
      titleKey: this.currentTitleKey,
      routeTo: this.routeTo,
      isExternal: this.routeTo.length > 0 && this.isExternalUrl(this.routeTo[0])
    });

    this.clicked.emit();
    if (this.routeTo.length > 0) {
        // the first element of the array is the URL
        // and additional elements are route parameters for internal routing
        const url = this.routeTo[0];

        if (this.isExternalUrl(url)) {
            // Validate external URL before navigation
            if (!this.isValidExternalUrl(url)) {
              this.alertService.openDialog('Virheellinen URL', 'URL-osoite ei ole sallittu');
              return;
            }
            // Navigate to external URL
            this.analytics.trackAction('navigate_external', 'home', 'home-card', this.translatedTitle, { url });
            window.open(url, '_blank', 'noopener,noreferrer');
        } else {
            // Navigate internally within the Angular app
            // 'routeTo' array is passed as is
            this.router.navigate(this.routeTo);
        }
    }
}

// Helper function to check if a URL is external
isExternalUrl(url: string): boolean {
    // Simple check to see if URL starts with 'http://' or 'https://'
    return /^(http|https):\/\//.test(url);
}

// Helper function to validate external URLs
isValidExternalUrl(url: string): boolean {
    try {
        const parsedUrl = new URL(url);
        // Whitelist of allowed domains for external navigation
        const allowedDomains = [
            'app.falcony.io',
            'falcony.io',
            // Add other trusted domains as needed
        ];
        return allowedDomains.some(domain =>
            parsedUrl.hostname === domain || parsedUrl.hostname.endsWith('.' + domain)
        );
    } catch {
        return false;
    }
}
}
